import { render } from "./SerpSuggestedCompetitorsModal.vue?vue&type=template&id=66123d2d&scoped=true"
import script from "./SerpSuggestedCompetitorsModal.vue?vue&type=script&lang=js"
export * from "./SerpSuggestedCompetitorsModal.vue?vue&type=script&lang=js"

import "./SerpSuggestedCompetitorsModal.vue?vue&type=style&index=0&id=66123d2d&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66123d2d"]])

export default __exports__